import { render, staticRenderFns } from "./AddPoll.vue?vue&type=template&id=7535622a&scoped=true"
import script from "./AddPoll.vue?vue&type=script&lang=js"
export * from "./AddPoll.vue?vue&type=script&lang=js"
import style0 from "./AddPoll.vue?vue&type=style&index=0&id=7535622a&prod&scoped=true&lang=css"
import style1 from "./AddPoll.vue?vue&type=style&index=1&id=7535622a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7535622a",
  null
  
)

export default component.exports